export default {
    TOKEN_VERIFICATION_STR: 'Connected',
    ERROR_CREDENTIALS: 'Wrong Credentials',
    ERROR_USER_EXIST: 'User already logged in',
    TOKEN_EXPIRED: 'Token has expired'
};
